import styled from 'styled-components';

const LeftPartStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  
  padding-top: 40px;
  max-width: 1040px;

  @media (min-width: 768px) {
    padding-top: 80px;
    padding-bottom: 80px;
    gap: 32px;
  }
  
  @media (min-width: 1280px) {
    justify-content: center;
    gap: 60px;
  }
  
  .logoWrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 4px;
    
    opacity: 0;
    transform: translateY(20%);
    transition: .6s opacity, .6s transform;
    
    @media (min-width: 768px) {
      flex-direction: row;
      gap: 16px;
    }
    
    &.inView {
      opacity: 1;
      transform: translateY(0);
    }
    
    h2 {
      font-size: 20px;
      line-height: 32px;

      @media (min-width: 768px) {
        font-size: 32px;
        line-height: 40px;
      }
    }
  }

  .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 20px 24px;
    width: 100%;

    background: #25A4E2;
    border: 4px solid #25A4E2;
    box-sizing: border-box;
    border-radius: 16px;
    color: var(--button-text);
    font-family: var(--title-font);

    transition: .3s ease background-color, .3s ease border-color;
  }
  
  .mainContent {
    h1 {
      margin-bottom: 32px;
      
      font-size: 24px;
      line-height: 36px;
      letter-spacing: -0.24px;
      
      opacity: 0;
      transform: translateY(20px);
      transition: 0.6s opacity, 0.6s transform;
      
      &.inView {
        opacity: 1;
        transform: translateY(0);
      }
      
      @media (min-width: 768px) {
        font-size: 40px;
        line-height: 56px;
        letter-spacing: -0.4px;
      }
    }
    
    ul {
      display: flex;
      flex-direction: column;
      gap: 16px;
      
      li {
        display: flex;
        gap: 12px;

        font-size: 16px;
        line-height: 140%;
        
        svg {
          transform: translateX(-10px);
          opacity: 0;
          transition: .3s ease opacity, .3s ease transform;
        }
        
        span {
          opacity: 0;
          transition-delay: .2s;
          transition: .3s ease opacity;
        }
        
        &.inView {
          svg {
            transform: translate(0, 2px);
            opacity: 1;
          }

          span {
            opacity: 1;
          }
        }

        @media (min-width: 768px) {
          font-size: 20px;
          line-height: 140%;
          
          svg {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }
  
  .buttonWrapper {
    opacity: 0;
    transform: translateY(20px);
    transition: 0.6s opacity, 0.6s transform;

    &.inView {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (min-width: 768px) {
    .button {
      width: fit-content;
    }
  }

  .button:hover {
    background: #0077B2;
    border: 4px solid #0077B2;
  }

  .button:active {
    background: #25A4E2;
    border: 4px solid #25A4E2;
  }
`;

export default LeftPartStyles;
